import React from 'react';
import { useDispatch } from 'react-redux';
import { getMessage } from '@tcc/i18n';
import { ModalSize } from '../../../../types';
import styles from '../RegionNoteForm.css';
import ConfirmationModal from '../../../../containers/Modal/ConfirmationModal';
import { resizeModal } from '../../../../actions/modalActions';

type DeleteConfirmationModalProps = {
  confirmTitleKey: string;
  removeAllComments: () => void,
  setDeleteConfirmationModal: (value: boolean) => void,
  isLoading: boolean,
  handleClickCancel: () => void,
};

export const DeleteConfirmationModal = ({
  confirmTitleKey,
  removeAllComments,
  setDeleteConfirmationModal,
  isLoading,
  handleClickCancel,
}: DeleteConfirmationModalProps) => {
  const dispatch = useDispatch();

  return (
    <div
      className={styles.confirmationModalContainer}
      data-test-id="region-note-form-delete-confirmation-modal"
    >
      <ConfirmationModal
        confirmButtonText={getMessage(confirmTitleKey)}
        handleClickConfirm={() => {
          removeAllComments();
        }}
        handleClickGoBack={() => {
          dispatch(resizeModal(ModalSize.L));
          setDeleteConfirmationModal(false);
        }}
        isLoading={isLoading}
        title={getMessage('deleteConfirmationModal.title')}
        handleClickCancel={handleClickCancel}
      />
    </div>
  );
};
